import React from 'react';
import { Input } from '@chakra-ui/react';
import PhoneInput from 'react-phone-number-input';
import styled from 'styled-components';

import 'react-phone-number-input/style.css';

const PhoneInputWithFlags = ({ ...props }: any): JSX.Element => {
  return (
    <Container>
      <Input as={PhoneInput} defaultCountry={props.defaultCountry} {...props} />
    </Container>
  );
};

const Container = styled.div`
  [type='tel'] {
    min-width: 0px;
    outline: 2px solid transparent;
    outline-offset: 2px;
    position: relative;
    appearance: none;
    transition-property: var(--chakra-transition-property-common);
    transition-duration: var(--chakra-transition-duration-normal);
    font-size: var(--chakra-fontSizes-md);
    padding-inline-start: var(--chakra-space-4);
    padding-inline-end: var(--chakra-space-4);
    border-radius: 8px;
    background: var(--chakra-colors-gray-50);
    border: var(--chakra-borders-none);
    color: var(--chakra-colors-gray-800);
    padding-top: var(--chakra-space-2);
    padding-bottom: var(--chakra-space-2);
  }
`;

export default PhoneInputWithFlags;
